import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { NewsLetterServices } from "../api";

const onDefaultError = (error) => {
  toast.error(error.message);
};
/**
 * Hook for Admin News Letter Master section
 */
const useListNewsLetter = ([page_no], onSuccess, onError = onDefaultError) => {
  return useQuery(
    ["newsletter-list", page_no],
    NewsLetterServices.newsletterList,
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};
const useAddNewsLetter = (onSuccess, onError = onDefaultError) => {
  return useMutation(NewsLetterServices.addNewsLetter, {
    onSuccess,
    onError,
  });
};
const useUpdateNewsLetter = (onSuccess, onError = onDefaultError) => {
  return useMutation(NewsLetterServices.updateNewsLetter, {
    onSuccess,
    onError,
  });
};
const useViewNewsLetter = (id, onSuccess, onError = onDefaultError) => {
  return useQuery(
    "newsletter-view",
    () => NewsLetterServices.viewNewsLetter({ id }),
    {
      onSuccess,
      onError,
    }
  );
};
const useNewsLetterDelete = (onSuccess, onError = onDefaultError) => {
  return useMutation(NewsLetterServices.deleteNewsLetter, {
    onSuccess,
    onError,
  });
};
export {
  useListNewsLetter,
  useAddNewsLetter,
  useUpdateNewsLetter,
  useViewNewsLetter,
  useNewsLetterDelete,
};
